import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { Config, UpdateConfig } from 'interfaces/api/config.interfaces'
import { axios } from 'modules/axios'

const get = async (): GetOneResponse<Config> => {
  const { data: response } = await axios.request<Config>({
    method: 'GET',
    url: endpoints.config.getConfig(),
  })
  return response
}

const update = async (data: UpdateConfig): Promise<void> => {
  const { data: response } = await axios.request({
    method: 'PATCH',
    url: endpoints.config.updateConfig(),
    data,
  })
  return response
}

export const configApi = {
  update,
  get,
}
